import { createContext } from 'react';

import { Context } from '../../../types';
import { CommissionType } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<CommissionType>>(getContextDefaultValues(api));
